import Vue from "vue";
import Axios from "axios";
import store from "../store";
import router from "../router";

Axios.defaults.baseURL = process.env.VUE_APP_API_URL || "";
// access token
if (store.getters["auth/isLoggedIn"]) {
    Axios.defaults.headers.common["Authorization"] = store.state.auth.token;
}

// intecetpros
Axios.interceptors.response.use(
    function (response) {
        return response;
    },
    async function (error) {
        const originalRequest = error.config;

        if (
            error.response &&
            error.response.status &&
            error.response.status === 401 &&
            !originalRequest._retry
        ) {
            originalRequest._retry = true;

            try {
                const token = await store.dispatch("auth/refreshToken");
                originalRequest.headers["Authorization"] = token;

                return Axios(originalRequest);
            } catch (refreshErr) {
                alert(refreshErr.message || 'กรุณา Login ใหม่อีกครั้ง');
                store.dispatch('auth/clearToken');
                if (router.currentRoute.path !== "/login") {
                    router.push({
                        path: "/login",
                    });
                }
            }

        }


        return Promise.reject(error);
    }
);
/** APPLY TO VUE */
Vue.prototype.$axios = Axios;